export default {
  getAllRocks(state) {
    return state.rocks;
  },
  getOneRock(state) {
    return state.oneRock;
  },
  getPageTitle(state) {
    return state.currentTitle;
  },
  getQuerySuggestions(state) {
    return state.querySuggestions.sort(
      new Intl.Collator(state.currentLanguage).compare,
    );
  },
  getResults(state) {
    return state.results;
  },
  getNoMatch(state) {
    return state.noMatch;
  },
};
